import styled from "styled-components";
import { ArrowDirections } from "./ArrowIcon";

const getRotateAngle = (direction) => {
  let index = 0;

  for (let i = 0; i < ArrowDirections.length; i++) {
    if (ArrowDirections[i] === direction) {
      index = i;
      break;
    }
  }

  return index * 45;
};

export const StyledIcon = styled.svg`
  transform: ${({ direction }) => `rotate(${getRotateAngle(direction)}deg)`};
  flex-shrink: 0;
  transition: transform 0.3s ease-in-out;
  .fill {
    fill: ${({ theme }) => theme.palette.common.text.primary};
  }
`;
